import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmartUpgradeDialog',
  props: {
    dialogPromiseHandlers: null
  },
  setup(__props: any) {

const props = __props as {
	dialogPromiseHandlers: { resolve: () => void; reject: () => void };
}

const isLoading = ref(false);

const { setIsSmartUpgradeEnabled } = useBilling();


const close = () => {
	props.dialogPromiseHandlers.resolve();
	AppDialogManagerService.closeCurrentDialog();
};
const allowSmartUpgrade = async () => {
	isLoading.value = true;
	try {
		await setIsSmartUpgradeEnabled({ isSmartUpgradeEnabled: true });
		close();
	} catch (e) {
		console.error('allowSmartUpgrade  e:', e);
	} finally {
		isLoading.value = false;
	}
};

return { __sfc: true,isLoading, setIsSmartUpgradeEnabled, props, close, allowSmartUpgrade, AppDialog }
}

})